document.addEventListener("DOMContentLoaded", function(){

const trigger = document.querySelector(".search-trigger");
const modal = document.querySelector(".search-modal");
const closeBtn = document.querySelector(".close-search");
const input = document.querySelector("#custom-search-input");
const pills = document.querySelectorAll(".filter-pill");

if(trigger){
trigger.addEventListener("click", () => {
modal.classList.add("open");
});
}

if(closeBtn){
closeBtn.addEventListener("click", () => {
modal.classList.remove("open");
});
}

if(input){

input.addEventListener("input", function(){

let value = this.value.toLowerCase();

pills.forEach(pill => {

let text = pill.dataset.originalText;

if(!value){
pill.innerHTML = text;
pill.style.display = "";
return;
}

if(text.toLowerCase().includes(value)){

let regex = new RegExp(`(${value})`, "gi");

pill.innerHTML = text.replace(regex,"<b>$1</b>");

pill.style.display = "";

}else{

pill.style.display = "none";

}

});

});

}

});
document.addEventListener("click", function(e){

const pill = e.target.closest(".filter-pill");
const family = e.target.closest(".scent-family-card button");

if(pill){
let text = pill.dataset.originalText || pill.innerText;
window.location.href = `/search?q=${encodeURIComponent(text)}`;
}

if(family){
let text = family.dataset.family;
window.location.href = `/search?q=${encodeURIComponent(text)}`;
}

});